import * as React from 'react';
import { ArrowUpload32Regular } from '@fluentui/react-icons';
import IFile from '../../../redux/types/IFiles';
import { StorageService } from '../../services/StorageService';
import { ContainerDetailsWindow, IContainerDetailsWindowProps } from './ContainerDetailsWindow';
import {
    ERROR_OBTAINING_SAS, ERROR_UPLOADING_FILE_SAS,
    OBTAINED_SAS,
    REQUEST_SAS,
    UPLOADING_FILE_SAS, UPLOAD_COMPLETED
} from './ContainerDetailsWindowFields';
import { MessageBanner, MessageType } from '../../../repertoire/components/messageBanner/MessageBanner';
import { CURRENT_USER_NAME_KEY } from '../../../redux/services/AccountSessionStorage';
interface IUploadBulkWorksContainerDetailsWindowProps
	extends IContainerDetailsWindowProps {
	currentUserNameNumber: string;
	undoUsageIngestion?: (fileName: string) => void;
}

export class UploadBulkWorksContainerDetailsWindow extends ContainerDetailsWindow {
    constructor(props: IUploadBulkWorksContainerDetailsWindowProps) {
        super(props);
        this.state = {
        	...this.state,
			uploadSuccess: false,
			uploadInProgress: false
		};
    }


    uploadFile(newFile: IFile, path: string, file: any) {
        const {
            addFileToUpload,
            setProgressUploadFileProccess,
            setInDropZone } = this.props;

        addFileToUpload(newFile, true);

        setInDropZone(false);

        setProgressUploadFileProccess(this.viewData[REQUEST_SAS], newFile, false);

        return Promise.resolve(
            StorageService.getUploadUri(path, false).then(
                (uri: string) => {
                    if (!uri || uri.length === 0) {
                        setProgressUploadFileProccess(this.viewData[ERROR_OBTAINING_SAS], newFile, true);
                        return false;
                    }
                    this.setState({uploadInProgress: true, uploadSuccess:false});
                    setProgressUploadFileProccess(this.viewData[OBTAINED_SAS], newFile, false);
                    setProgressUploadFileProccess(this.viewData[UPLOADING_FILE_SAS], newFile, false);

                    return StorageService.uploadFile(uri, file).then(
                        (res: boolean) => {
                            if (res) {
                                this.setState({uploadInProgress: false, uploadSuccess:true});
                                setProgressUploadFileProccess(this.viewData[UPLOAD_COMPLETED], newFile, true);
                                return true;
                            }
                        },
                        reject => {
                            setProgressUploadFileProccess(this.viewData[ERROR_UPLOADING_FILE_SAS], newFile, true);

                            return false;
                        }
                    )
                        .catch(error => {
                            return false;
                        })
                },
                reject => {
                    setProgressUploadFileProccess(this.viewData[ERROR_OBTAINING_SAS], newFile, true);
                    return false;
                }
            )
        )
    }

    handleDrop = e => {
        const { cleanUploadFilesState } = this.props;
        cleanUploadFilesState();

        const files = [...e.dataTransfer.files];
        files.forEach(file => {
            const newFile: IFile = super.createUploadFile(file);
            const timestamp = Date.now();
            const username = sessionStorage.getItem(CURRENT_USER_NAME_KEY);
            const fullPath = `package-files/works/input/${username}_${timestamp}_${file.name}`;
            this.uploadFile(newFile, fullPath, file)
        });
        e.preventDefault();
    };

    handleDragLeave = e => {
        const { setInDropZone } = this.props;
        setInDropZone(false);
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragEnd = e => {
        const { setInDropZone } = this.props;
        setInDropZone(false);
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragEnter = e => {
        const { setInDropZone } = this.props;
        setInDropZone(true);
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragOver = e => {
        const { setInDropZone } = this.props;
        setInDropZone(true);
        e.preventDefault();
        e.stopPropagation();
    };

    resetMessage = () => {
        this.setState({uploadSuccess:false,uploadInProgress:false});
    }
    render() {
        if (!this.state.loaded)
            return <div className="loading" />
        const { pageContentIsActive, isDropZone } = this.props;

        let className = "container-fluid ";
        let dragAndDropClassName = "dropBox notToDisplay";

        if (pageContentIsActive) {
            className = className + " active";
        }

        if (isDropZone) {
            dragAndDropClassName = "dropBox display";
        }
        return (
            <>
             {(this.state.uploadSuccess && !this.state.uploadInProgress ) && <div className="row">
                    <MessageBanner resetMessageBanner={this.resetMessage} messageType={MessageType.Success} messages={['File uploaded successfully.']} />
                </div>}
            {(this.state.uploadInProgress && !this.state.uploadSuccess) && <div className="row">
                    <MessageBanner resetMessageBanner={this.resetMessage} messageType={MessageType.Warning} messages={['File upload in progress.']} />
                </div>}
                <div style={{ height: '114px' }}>
                    <div className={`${className} flexRow flexJustifyContentCenter`} style={{ height: '114px' }}>
                        <div className="row flexRow flexJustifyContentCenter widthFull">
                            <div className="form-group" style={{ width: '90%', height: '114px' }}>
                                <div>
                                    <div id="DragAndDropArea" className="dragAndDrop" style={{ height: '114px' }} onDragOver={undefined} onDragEnter={undefined}>
                                        <div className={dragAndDropClassName} style={{ height: '114px' }}
                                            onDrop={this.handleDrop}
                                            onDragLeave={this.handleDragLeave}
                                            onDragEnd={this.handleDragEnd}
                                            onDragOver={this.handleDragOver}
                                            onDragEnter={this.handleDragEnter}>
                                            <div className="dropBoxContent paddingHalf">
                                                <div className="row">
                                                    <ArrowUpload32Regular
                                                        className="icon"
                                                        aria-hidden="true"
                                                        style={{ width: '2rem', height: '2rem', marginBottom: '1rem' }}
                                                    />
                                                </div>
                                                <div className="row dropText">
                                                    <span className="dopBoxContent-Heading">Drop files to upload</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div></>


        )
    }
}